<template>
  <v-container fluid>
    <v-row justify="end">
      <v-col>
        <h1>{{ $t("invoicing.sales.title") }}</h1>
      </v-col>
      <v-col cols="auto">
        <v-btn class="ma-2" color="primary" @click="navigate()">
          {{ $t("invoicing.transportEvents") }}
        </v-btn>
      </v-col>
    </v-row>
    <ReadyForSalesInvoicingTable v-if="!byFilter"></ReadyForSalesInvoicingTable>
    <ReadyForSalesInvoicingByFilter v-if="byFilter"></ReadyForSalesInvoicingByFilter>
  </v-container>
</template>

<script>
import ReadyForSalesInvoicingTable from "../components/Invoicing/ReadyForSalesInvoicingTable";
import ReadyForSalesInvoicingByFilter from "../components/Invoicing/ReadyForSalesInvoicingByFilter";

export default {
    components: { ReadyForSalesInvoicingTable, ReadyForSalesInvoicingByFilter },
    methods: {
        navigate() {
            this.$router.push({ name: "Invoicing" });
        }
    },
    computed: {
        byFilter() {
            // TODO: delete when every customer uses by filter
            if (this.$store.state.user.tenant === "kaista" || this.$store.state.user.tenant === "taksi1" || this.$store.state.user.tenant === "pohjanmaa-sote") {
                return true;
            }
            return false;
        }
    }
};
</script>

<style scoped>
h1 {
  margin-bottom: 1rem;
}
</style>
